
<div class="landing">
  <div class="landing--left">
    @if (secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('DASHBOARD_VIEW') | async) {
      <mat-card class="landing__item"
        [routerLink]=getRouterLink()>
        <mat-card-content>
          <img class="landing__item__icon"
            src="assets/icons/reports.svg"
            alt="reports">
        </mat-card-content>
        <mat-card-footer class="landing__item__header">
          {{'Reports' | translate}}
        </mat-card-footer>
      </mat-card>
    } @else {
      @if (secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('CONTRIBUTION_REPORT_VIEW') | async) {
        <mat-card class="landing__item"
          routerLink="/reporting/contribution">
          <mat-card-content>
            <img class="landing__item__icon"
              src="assets/icons/reports.svg"
              alt="reports">
          </mat-card-content>
          <mat-card-footer class="landing__item__header">
            {{'Reports' | translate}}
          </mat-card-footer>
        </mat-card>
      } @else {
        @if (secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('FORM_SUMMARY_REPORT') | async) {
          <mat-card class="landing__item"
            routerLink="/reporting/form-summary">
            <mat-card-content>
              <img class="landing__item__icon"
                src="assets/icons/reports.svg"
                alt="reports">
            </mat-card-content>
            <mat-card-footer class="landing__item__header">
              {{'Reports' | translate}}
            </mat-card-footer>
          </mat-card>
        } @else {
          @if (secureLocalService.isNotAnAgent() &&permissionService.hasAtLeastOnePermission('REPORT_BUILDER','QRVEY_REPORTS','GRAFANA') | async) {
            <mat-card class="landing__item"
              [routerLink]="getRouterLink()">
              <mat-card-content>
                <img class="landing__item__icon"
                  src="assets/icons/reports.svg"
                  alt="reports">
              </mat-card-content>
              <mat-card-footer class="landing__item__header">
                {{'Reports' | translate}}
              </mat-card-footer>
            </mat-card>
          }
        }
      }
    }





    @if (secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('USER_VIEW', 'VIBA_ADMIN') | async) {
      <mat-card class="landing__item"
        routerLink="/users">
        <mat-card-content>
          <img class="landing__item__icon"
            src="assets/icons/users.svg"
            alt="users">
        </mat-card-content>
        <mat-card-footer class="landing__item__header">
          {{'Users' | translate}}
        </mat-card-footer>
      </mat-card>
    }
    @if (secureLocalService.isNotAnAgent() && permissionService.hasPermission('STORE_VIEW') | async) {
      <mat-card class="landing__item"
        routerLink="/stores">
        <mat-card-content>
          <img class="landing__item__icon"
            src="assets/icons/stores.svg"
            alt="stores">
        </mat-card-content>
        <mat-card-footer class="landing__item__header">
          {{labelingService.getStoresLabel() | async}}
        </mat-card-footer>
      </mat-card>
    }
    <!--    <mat-card class="landing__item"-->
    <!--              *ngIf="secureLocalService.isNotAnAgent() && permissionService.hasPermission('ACTIVITY') | async"-->
    <!--              routerLink="/batches/jobs">-->
    <!--      <mat-card-content>-->
    <!--        <img class="landing__item__icon"-->
    <!--             src="assets/icons/activities.svg"-->
    <!--             alt="activities">-->
  <!--      </mat-card-content>-->
  <!--      <mat-card-footer class="landing__item__header">-->
  <!--        {{'Jobs' | translate}}-->
<!--      </mat-card-footer>-->
<!--    </mat-card>-->
<!--    <mat-card class="landing__item"-->
<!--              *ngIf="secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('CALENDAR_VIEW', 'CALENDAR_MODIFY', 'OUT_OF_OFFICE_EVENT_MODIFY_RECEIVE_ALERTS',-->
<!--            'OUT_OF_OFFICE_EVENT_VIEW', 'ACTIVITY_ADMIN', 'ACTIVITY') | async"-->
<!--              routerLink="/calendar">-->
<!--      <mat-card-content>-->
<!--        <img class="landing__item__icon"-->
<!--             src="assets/icons/calendar.svg"-->
<!--             alt="calendar">-->
<!--      </mat-card-content>-->
<!--      <mat-card-footer class="landing__item__header">-->
<!--        {{'Calendar' | translate}}-->
<!--      </mat-card-footer>-->
<!--    </mat-card>-->
<!--    <mat-card class="landing__item"-->
<!--              *ngIf="secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY') | async; else formNoAdmin"-->
<!--              routerLink="/visits/adminForms">-->
<!--      <mat-card-content>-->
<!--        <img class="landing__item__icon"-->
<!--             src="assets/icons/forms.svg"-->
<!--             alt="forms">-->
<!--      </mat-card-content>-->
<!--      <mat-card-footer class="landing__item__header">-->
<!--        {{'Forms' | translate}}-->
<!--      </mat-card-footer>-->
<!--    </mat-card>-->

<!--    <ng-template #formNoAdmin>-->
<!--      <mat-card class="landing__item"-->
<!--                *ngIf="secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY', 'ADHOC_VISIT_EDIT', 'STORE_VISIT_EDIT') | async; else formNoEdit"-->
<!--                routerLink="/visits/userForms">-->
<!--        <mat-card-content>-->
<!--          <img class="landing__item__icon"-->
<!--               src="assets/icons/forms.svg"-->
<!--               alt="forms">-->
<!--        </mat-card-content>-->
<!--        <mat-card-footer class="landing__item__header">-->
<!--          {{'Forms' | translate}}-->
<!--        </mat-card-footer>-->
<!--      </mat-card>-->
<!--    </ng-template>-->

<!--    <ng-template #formNoEdit>-->
<!--      <mat-card class="landing__item"-->
<!--                *ngIf="secureLocalService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('ADHOC_VISIT_VIEW', 'STORE_VISIT_VIEW') | async"-->
<!--                routerLink="/visits">-->
<!--        <mat-card-content>-->
<!--          <img class="landing__item__icon"-->
<!--               src="assets/icons/forms.svg"-->
<!--               alt="visits">-->
<!--        </mat-card-content>-->
<!--        <mat-card-footer class="landing__item__header">-->
<!--          {{'Visits' | translate}}-->
<!--        </mat-card-footer>-->
<!--      </mat-card>-->
<!--    </ng-template>-->

    @if (permissionService.hasPermission('VIBA_USER') | async) {
<mat-card class="landing__item"
             
              routerLink="/viba/agent">
    <mat-card-content>
      <img class="landing__item__icon"
        src="assets/icons/viba-agent.svg"
        alt="VIBA Agent">
    </mat-card-content>
    <mat-card-footer class="landing__item__header">
      {{'VIBA Agent' | translate}}
    </mat-card-footer>
  </mat-card>
}

@if (secureLocalService.isNotAnAgent() && permissionService.hasPermission('VIBA_ADMIN') | async) {
  <mat-card class="landing__item"
    routerLink="/viba/admin">
    <mat-card-content>
      <img class="landing__item__icon"
        src="assets/icons/viba-admin.svg"
        alt="VIBA Admin">
    </mat-card-content>
    <mat-card-footer class="landing__item__header">
      {{'VIBA Admin' | translate}}
    </mat-card-footer>
  </mat-card>
}

<!--    <mat-card class="landing__item"-->
<!--              *ngIf="secureLocalService.isNotAnAgent() && permissionService.hasPermission('SALES_GOALS_IMPORT') | async"-->
<!--              routerLink="/imports/imports">-->
<!--      <mat-card-content>-->
<!--        <img class="landing__item__icon"-->
<!--             src="assets/icons/sales-goals.svg"-->
<!--             alt="Imports">-->
<!--      </mat-card-content>-->
<!--      <mat-card-footer class="landing__item__header">-->
<!--        {{'Imports' | translate}}-->
<!--      </mat-card-footer>-->
<!--    </mat-card>-->

</div>

@if (!(permissionService.hasPermission('ACTIVITY') | async)) {
  <div
    class="landing--right" >
    <app-metrics-widget></app-metrics-widget>
  </div>
}
</div>



